module.exports = __webpack_public_path__ + "img/48.c471193e.png";